import { reactive } from 'vue';

export const queryForm = reactive({
  formItems: [
    {
      key: 'name',
      type: 'input',
      label: '商品名称',
      placeholder: '请输入商品名称',
    },
  ],
});
export const columns = [
  {
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'selection',
    reserveSelection: true,
  },
  {
    prop: 'logo_url',
    label: '商品图片',
    width: 120,
    scopedSlots: 'logo_url',
  },
  {
    prop: 'name',
    label: '商品名称',
  },
  {
    prop: 'code',
    label: '商品编号',
  },
];

// //已选择商品
export const selectedGoodsColumn = [
  {
    prop: 'logo_url',
    label: '商品图片',
    width:120,
    scopedSlots: 'logo_url',
  },
  {
    prop: 'name',
    label: '商品名称',
    showOverflowTooltip: true
  },
  {
    prop: 'code',
    label: '商品编号',
  },
  {
    prop: 'operation',
    label: '操作',
    fixed: 'right',
    width:80,
    scopedSlots: 'operation',
  },
];
